<template>
    <div class="p-5 flex flex-col justify-center items-center w-full ">



        <div class="grid grid-cols-2 lg:grid-cols-4 gap-5 w-full mb-7">
            <div class="bg-white shadow-md rounded-lg p-5 text-center border border-gray-200">
                <h3 class="text-gray-500 text-sm"> Total des Soumissions</h3>
                <p class="text-2xl font-semibold text-primary">{{ totalSubmissions }}</p>
            </div>

            <div class="bg-white shadow-md rounded-lg p-5 text-center border border-gray-200">
                <h3 class="text-gray-500 text-sm">Top Culture</h3>
                <p class="text-2xl font-semibold text-primary">{{ topCulture }}</p>
            </div>
            <div class="bg-white shadow-md rounded-lg p-5 text-center border border-gray-200">
                <h3 class="text-gray-500 text-sm"> Moyenne des Hectares</h3>
                <p class="text-2xl font-semibold text-primary">{{ avgHectares }}</p>
            </div>
            <div class="bg-white shadow-md rounded-lg p-5 text-center border border-gray-200">
                <h3 class="text-gray-500 text-sm">Top Fonction</h3>
                <p class="text-2xl font-semibold text-primary">{{ mostPopularFunction }}</p>
            </div>

        </div>



        <div class="flex justify-end items-center w-full mb-2">
            <div
                class="bg-primary hover:cursor-pointer text-white hover:scale-105 transition duration-200 px-3 py-2 rounded shadow-lg flex  space-x-1 text-sm">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                    </svg>

                </div>
                <div>
                    Télécharger Fichier Excel
                </div>

            </div>
        </div>


        <div class="relative overflow-x-auto shadow-md sm:rounded-lg w-full">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 ">
                <thead class="text-xs text-white  bg-primary  ">
                    <tr>
                        <th scope="col" class="px-6 py-3">Nom</th>
                        <th scope="col" class="px-6 py-3">Prénom</th>
                        <th scope="col" class="px-6 py-3">Téléphone</th>
                        <th scope="col" class="px-6 py-3">Fonction</th>
                        <th scope="col" class="px-6 py-3">Société</th>
                        <th scope="col" class="px-6 py-3">Hectares</th>
                        <th scope="col" class="px-6 py-3">Wilaya</th>
                        <th scope="col" class="px-6 py-3">Commune</th>
                        <th scope="col" class="px-6 py-3">Cultures</th>
                        <th scope="col" class="px-6 py-3">Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in submissions" :key="index"
                        class="bg-white border-b   border-gray-200 hover:bg-gray-50 ">
                        <td class="px-6 py-4">{{ row.lastName }}</td>
                        <td class="px-6 py-4">{{ row.firstName }}</td>
                        <td class="px-6 py-4">{{ row.phone }}</td>
                        <td class="px-6 py-4">{{ row.function }}</td>
                        <td class="px-6 py-4">{{ row.company }}</td>
                        <td class="px-6 py-4">{{ row.hectares }}</td>
                        <td class="px-6 py-4">{{ getWilayaName(row.wilaya) }}</td>
                        <td class="px-6 py-4">{{ getCommuneName(row.wilaya, row.commune) }}</td>
                        <td class="px-6 py-4">{{ row.cultures.join(', ') }}</td>
                        <td class="px-6 py-4">{{ row.created_at.split('T')[0] }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>


<script setup>
import { submissions } from '@/data/submitions'
import { wilayas, wilayas_communes } from 'dz-communes'
import { computed } from 'vue'

// Get Wilaya Name
const getWilayaName = (id) => {
    const wilaya = wilayas.find(w => w.wilayacode === "" + id)
    return wilaya ? wilaya.name : 'N/A'
}

// Get Commune Name
const getCommuneName = (wilayaId, postalCode) => {

    const wilayaData = wilayas_communes.find(w => w.wilayacode === "" + wilayaId)
    console.log('wilayaData :>> ', wilayaData);
    const commune = wilayaData?.communes.find(c => c.postalcode === "" + postalCode)
    return commune ? commune.name : 'N/A'
}

// Stats
const totalSubmissions = computed(() => submissions.length)



const topCulture = computed(() => {
    const count = {}
    submissions.forEach(s => {
        s.cultures.forEach(culture => {
            count[culture] = (count[culture] || 0) + 1
        })
    })
    return Object.entries(count).sort((a, b) => b[1] - a[1])[0]?.[0] || 'N/A'
})

const avgHectares = computed(() => {
    const total = submissions.reduce((sum, s) => sum + (Number(s.hectares) || 0), 0)
    return (total / submissions.length).toFixed(1)
})

const mostPopularFunction = computed(() => {
    const funcCount = {};
    submissions.forEach(s => {
        const func = s.function || 'Inconnu';
        funcCount[func] = (funcCount[func] || 0) + 1;
    });
    const sorted = Object.entries(funcCount).sort((a, b) => b[1] - a[1]);
    return sorted.length > 0 ? sorted[0][0] : 'Inconnue';
});
</script>